import React from 'react';
import Image from 'next/image';

import { assetUrl } from '@whelk/const';
import { openLoginModal } from '@whelk/utils';
import { useTranslation } from 'react-i18next';

const SidebarLogin = () => {
  const { t } = useTranslation();
  return (
    <div className='text-col_text00 flex flex-col items-center justify-center'>
      <Image
        src={`${assetUrl}history-emp.png`}
        className='h-[120px] w-[120px]'
        width={120}
        height={120}
        alt='history-bg'
      />
      {t('login_to_view_topic_history')}
      <button
        className='bg-col_bg14 text-col_text00 mt-6 flex h-[36px] w-[104px] items-center justify-center rounded-md px-4 font-[500]'
        onClick={() => openLoginModal('login_click')}
      >
        {t('title_login')}
      </button>
    </div>
  );
};

export default SidebarLogin;
